import React from 'react';
import {
  defaultTheme,
  Provider as SpectrumProvider
} from '@adobe/react-spectrum';
import { AIAssistant as AIAssistantComponent } from '../components/AIAssistant';

export { setConfig, getConfig, type AssistantConfig } from '../utils/config';

export interface RoadmapContext {
  route?: string;
  dateRange?: { start: string; end: string };
  filters?: {
    productGroups?: string[];
    categories?: string[];
    status?: string[];
    tiers?: string[];
    audiences?: string[];
    products?: string[];
    events?: string[];
    surfaces?: string[];
    categoryProductCategories?: string[];
    categoryProductProducts?: string[];
    genAiFilters?: string[];
    revenueImpactFilters?: string[];
    momentTypeFilters?: string[];
  };
  issueId?: string;
  momentType?: string;
  [key: string]: unknown;
}

export interface AIAssistantRemoteProps {
  context?: RoadmapContext;
  isOpen?: boolean;
  onClose?: () => void;
  mode?: 'embedded' | 'overlay';
}

export default function AIAssistantDirect(props: AIAssistantRemoteProps) {
  return (
    <SpectrumProvider theme={defaultTheme}>
      <AIAssistantComponent
        mode={props.mode ?? 'embedded'}
        context={props.context}
        isOpen={props.isOpen}
        onClose={props.onClose}
      />
    </SpectrumProvider>
  );
}
